import { render, staticRenderFns } from "./AddNominationOnlinePayment.vue?vue&type=template&id=f814880e"
import script from "./AddNominationOnlinePayment.vue?vue&type=script&lang=js"
export * from "./AddNominationOnlinePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports